export enum UserGroups {
  Admin = 'admin',
  Global = 'global',
  Partner = 'partner',
  Client = 'client'
}

export const ROLE_MAP = {
  admin: 'admin',
  global: 'global',
  partner: 'partner',
  client: 'client'
};

// Courses
export const OWNER_COURSE_OPTIONS = [
  { key: 'all', isActiveOption: () => true, value: 'courses.tabs.all' },
  {
    key: 'gamelearn',
    isActiveOption: (component) => !component.isExpert,
    value: 'courses.tabs.gamelearn'
  },
  {
    key: 'myCourses',
    isActiveOption: (component) =>
      !component.isExpert && ((component.clientId && component.editorClient) || component.editorPartner),
    value: 'courses.tabs.myCourses'
  },
  {
    key: 'partner',
    isActiveOption: (component) =>
      !((component.isExpert || component.isDistributor) && !component.onClientDetail) &&
      component.partner &&
      component.editorPartner,
    value: 'partner.name'
  }
];

export const STYLE_FORM_SCOPES: Object = {
  csm: 'csm',
  supportSpecialist: 'supportSpecialist',
  expert: 'expert',
  distributor: 'distributor',
  distributorManager: 'distributorManager'
};

// Scorm Courses
export const BUTTON_ACTIONS = [
  { key: '1', value: 'courses.config.downloadScormFile' },
  { key: '2', value: 'courses.config.downloadDocumentationTitle' },
  { key: '3', value: 'actions.withdrawCourse' }
];

export const VIEWMODES = {
  cards: 'cards',
  list: 'list'
};

export const SCOPES = {
  courses: 'courses',
  clients: 'clients'
};

export const BUTTON_ACTIONS_COURSES = [
  { key: 'changeAccess', value: 'actions.changeAccess', profile: 'courses.changeAccessMode' },
  { key: 'shouldSendDiploma', value: 'actions.shouldSendDiploma', profile: 'courses.shouldSendDiploma' }
];

export const BUTTON_ACTIONS_COURSES_SCORM = [
  { key: 'shouldSendDiploma', value: 'actions.shouldSendDiploma', profile: 'courses.shouldSendDiploma' },
  { key: 'downloadScormFile', value: 'courses.config.downloadScormFile', profile: 'courses.scorm' },
  {
    key: 'downloadDocumentation',
    value: 'courses.config.downloadDocumentationTitle',
    profile: 'courses.download-documents'
  }
];
